import React from "react";
import PropTypes from "prop-types";

const ContactMessages = ({ msgEnvoye, msgError }) => (
  <div className="container mx-auto text-center mb-10 mt-5 px-10">
    {msgEnvoye ? (
      <div className="bg-green-200 rounded-lg mt-4 p-2 mx-auto container max-w-xs md:max-w-md">
        {msgEnvoye}
      </div>
    ) : null}
    {msgError ? (
      <div className="bg-red-200 rounded-lg mt-4 p-2 mx-auto container max-w-xs md:max-w-md">
        {msgError}
      </div>
    ) : null}
  </div>
);

ContactMessages.propTypes = {
  msgEnvoye: PropTypes.string,
  msgError: PropTypes.string,
};

export default ContactMessages;
